// extracted by mini-css-extract-plugin
export default {"ul":"cardpremium_ul__a7j5H","li":"cardpremium_li__GspH3","image":"cardpremium_image__Up8cF"};